import styled, { css } from 'styled-components'
import { COLORS } from '~/shared/constants/uiConstants'

const optionBaseStyles = css`
  display: block;
  width: 100%;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.GRAY_30};
`

const optionCheckedStyles = css`
  background: ${COLORS.PURPLE_100};
  border: 1px solid ${COLORS.PURPLE_500};
`

const checkboxTypeStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const checkboxUncheckedStyles = css`
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.WHITE};
`

export const StyledOption = {
  Wrapper: styled.label<{ $isCheckboxType: boolean; $isChecked?: boolean }>`
    ${optionBaseStyles}

    ${({ $isCheckboxType }) => $isCheckboxType && checkboxTypeStyles}

    ${({ $isCheckboxType, $isChecked }) =>
      // eslint-disable-next-line no-nested-ternary
      $isCheckboxType
        ? $isChecked
          ? optionCheckedStyles
          : checkboxUncheckedStyles
        : $isChecked
        ? optionCheckedStyles
        : ''}

    & > input {
      position: absolute;
      opacity: 0;
      pointer-events: none;
      width: 0;
      height: 0;
    }
  `,

  Checkbox: styled.div`
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: 2px solid ${COLORS.PURPLE_400};
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &.checked {
      border: none;
      background: ${COLORS.PURPLE_400};

      & > svg {
        position: absolute;
      }
    }
  `,
}
